// extracted by mini-css-extract-plugin
var _1 = "MinimizedModalsTray-moduletray__bmpEv";
export { _1 as "tray" }
